import {ChangeDetectionStrategy, Component} from '@angular/core';
import {NbButtonModule, NbComponentType, NbIconModule} from '@nebular/theme';
import {ChooseCatalogInputComponent} from '../../choose-catalog-input/choose-catalog-input.component';
import {DamChooseCatalogModalComponent} from '../dam-choose-catalog-modal/dam-choose-catalog-modal.component';

@Component({
  standalone: true,
  selector: 'app-choose-dam-catalog-input',
  templateUrl: './../../choose-catalog-input/choose-catalog-input.component.html',
  imports: [
    NbButtonModule,
    NbIconModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamChooseCatalogInputComponent extends ChooseCatalogInputComponent {
  modalComponent: NbComponentType = DamChooseCatalogModalComponent;
}
